<template>
  <div class="main">
    <div class="pageTitle">
      <p>密码</p>
    </div>
    <div style="margin-top:20px;">

      <el-row :gutter="0">
          <el-col :span="8">
              <el-form
                :show-message="false"
                :model="updatePasswordForm"
                :rules="rules"
                ref="updatePasswordForm"
                label-width="100px"
                size="small"
                label-position="left">
                <div style="margin-left:20px;">
                    <el-form-item label="旧密码" prop="oldPassword">
                      <el-input type="password" v-model="updatePasswordForm.oldPassword" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="newPassword">
                      <el-input type="password" v-model="updatePasswordForm.newPassword" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="newPassword2">
                      <el-input type="password" v-model="updatePasswordForm.newPassword2" autocomplete="off"></el-input>
                    </el-form-item>
                </div>

                <el-button size="small" @click="submitForm()" style="margin-left: 0;">更新密码</el-button>
              </el-form>
          </el-col>
          <el-col :span="16">
                
          </el-col>
       </el-row> 
    </div>
  </div>
</template>
<script>
import { hex_md5 } from "@/utils/MD5";
export default {
  data() {
    var password1Validator = (rule, value, callback) => {
      if (value === "") 
      {
        callback(new Error("请输入密码"));
      } else 
      {
        if (this.updatePasswordForm.newPassword2 !== "") 
        {
          this.$refs.updatePasswordForm.validateField("newPassword2");
        }
        callback();
      }
    };
    var password2Validator = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.updatePasswordForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } 
       else if(value.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,30}$/g) == null) //强密码验证
      {
        //https://c.runoob.com/front-end/854/
        //强密码(必须包含大小写字母和数字的组合，可以使用特殊字符，长度在6-30之间)
        //^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,30}$

        callback(new Error("密码必须 8 位以上，至少包含大小写字母和数字；"));
      }
      else {
        callback();
      }
    };
    return {
      updatePasswordForm: 
      {
        userId: this.$userContext.getUserId(),
        newPassword2: "",
        newPassword: "",
        oldPassword: ""
      },
      rules: 
      {
        newPassword: 
        [{ required: true, validator: password1Validator, trigger: "blur" }],
        newPassword2: 
        [{  required: true,validator: password2Validator, trigger: "blur" }],
        oldPassword: 
        [{ required: true, message: "请填写旧密码", trigger: "change" }]
      }
    };
  },
  methods: {
    submitForm() 
    {
      this.$refs["updatePasswordForm"].validate((valid,data) => 
      {
        if (!valid) 
        {
           this.$uiHelper.showValidationMessage(valid,data);
           return;
        } 

         let submitForm = 
          {
            userId:this.$userContext.getUserId(),
            oldPassword:hex_md5(this.updatePasswordForm.oldPassword).toUpperCase(),
            newPassword:hex_md5(this.updatePasswordForm.newPassword).toUpperCase()
          };
          this.$userApi.updatePassword(submitForm).then(res => 
          {
              if (res.data.successful) 
              {
                this.$message(
                {
                  message: "密码已更新，下次请使用新密码登录",
                  type: "success",
                  customClass: "successMsg",
                  duration: 2000
                });
              } else 
              {
                this.$alert(res.data.message, "提示");
              }
            });
      });
    },
    resetForm() {
      this.$refs["updatePasswordForm"].resetFields();
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/views/setting/password.vue